<template>
  <DContextMenu2 ref="contextMenuRef" :model="contextItems" />

  <div v-for="node in settingPanels[nodeType]" :key="node.key" class="my-1 flex flex-col">
    <Field
      :field="node"
      :value="getValue(node.key)"
      :module="module"
      :resetCounter="resetCounter"
      @change="handleChange(node.key, $event, arguments[1])"
      @contextmenu="handleContextMenu"></Field>
  </div>
</template>

<script setup>
import { settingPanels } from '@/constants/settingPanels';
import { DContextMenu2 } from '@disguise/cloud-ui';
import { computed, ref } from 'vue';
import Field from './Field.vue';

const props = defineProps({
  nodeType: {
    type: String,
    default: null,
  },
  module: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['update']);

const getValue = (key) => {
  if (!key || !props.module) return undefined;
  if (props.module[key] !== undefined) {
    return props.module[key]; // root fields
  }
  if (!props.module?.data) return undefined;
  return props.module.data[key];
};

const handleChange = (key, value, isRoot = false) => {
  emit('update', { key, value, isRoot });
};

const contextMenuRef = ref(null);
const currentField = ref(null);
const resetCounter = ref(0);

const isFieldLocked = computed(() => {
  if (!currentField.value) return false;
  const field = currentField.value;
  if (typeof field.disabled === 'function') {
    return !field.disabled(props.module?.data || {});
  }
  return false;
});

const contextItems = computed(() => {
  const items = [];
  if (currentField.value && !isFieldLocked.value && currentField.value.default != null) {
    items.push({
      label: 'Reset to Default',
      command: () => {
        if (currentField.value) {
          handleChange(currentField.value.key, currentField.value.default);
          resetCounter.value++;
        }
      },
    });
  }
  return items;
});

const handleContextMenu = ({ event, field }) => {
  currentField.value = field;
  contextMenuRef.value.show(event);
};
</script>
